import React, { ReactNode } from 'react'

import { QuickTip } from 'govwell-ui'

import HStack from 'src/govwell-ui/components/Flex/HStack'

import Text, { TextSize } from '../Typography/Text'

type Props = {
  label: ReactNode
  tooltip?: string
  isBold?: boolean
}

const DashboardLabel = ({ label, tooltip, isBold }: Props) => {
  return (
    <HStack gap={2}>
      {typeof label === 'string' ? (
        <Text size={TextSize.Base} strong={isBold}>
          {label}
        </Text>
      ) : (
        label
      )}
      {tooltip && <QuickTip content={tooltip} />}
    </HStack>
  )
}

export default React.memo(DashboardLabel)
